'use client';

import React, { useTransition } from 'react';
import NextLink from 'next/link';
import { useRouter } from 'next/navigation';
import { LoaderCircle } from 'lucide-react';

export default function LinkLoader({ href, children, replace, ...rest }: Parameters<typeof NextLink>[0]) {
  const router = useRouter();
  const [isPending, startTransition] = useTransition();

  return (
    <NextLink
      href={href}
      onClick={(e) => {
        e.preventDefault();
        startTransition(() => {
          const url = href.toString();
          if (replace) {
            router.replace(url);
          } else {
            router.push(url);
          }
        });
      }}
      {...rest}
    >
      {isPending && (
        <span className='mr-1'>
          <LoaderCircle width={10} height={10} className='animate-spin' />
        </span>
      )}
      {children}
    </NextLink>
  );
}
